import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../Api/feathers-client';

const initialState = {
    whoAmIData:{}
};

// NOTE: "We call a web service from here which is aysnc by nature so that we used 'createAsyncThunk' which is used for aysnc functions"

// Function [fetchWhoAmI] : To call a service to get whoami file data and then set that data in state varible 'whoAmIData' for global use throughout app

export const fetchWhoAmI = createAsyncThunk(
    'whoami/fetchWhoAmI',
    async (thunkAPI) => {
        const response = await api.service('files-read').get('.whoami');
        return response;
});


const installationSlice = createSlice({
    name: 'installation',
    initialState,
    reducers:{
        setWhoAmIData(state, {payload}){
            return {
              ...state,
              whoAmIData: payload
            }
        }
    },
    extraReducers: {
        [fetchWhoAmI.fulfilled]: (state, { payload }) => {
            state.whoAmIData = payload;
        }
    },
});

export const installationSliceActions = installationSlice.actions;

export default installationSlice;